export class ApiClient {
    constructor(baseUrl) {
        this.accessToken = null;
        this.refreshToken = null;
        this.baseUrl = baseUrl.replace(/\/+$/, '');
    }
    setTokens(accessToken, refreshToken) {
        this.accessToken = accessToken;
        this.refreshToken = refreshToken;
    }
    clearTokens() {
        this.accessToken = null;
        this.refreshToken = null;
    }
    getAccessToken() {
        return this.accessToken;
    }
    setOnRefreshFailed(cb) {
        this.onRefreshFailed = cb;
    }
    async request(method, path, body) {
        const url = `${this.baseUrl}${path}`;
        const headers = {
            'Content-Type': 'application/json',
        };
        if (this.accessToken) {
            headers['Authorization'] = `Bearer ${this.accessToken}`;
        }
        let res = await fetch(url, {
            method,
            headers,
            body: body ? JSON.stringify(body) : undefined,
        });
        // Auto-refresh on 401
        if (res.status === 401 && this.refreshToken) {
            const refreshed = await this.tryRefresh();
            if (refreshed) {
                headers['Authorization'] = `Bearer ${this.accessToken}`;
                res = await fetch(url, {
                    method,
                    headers,
                    body: body ? JSON.stringify(body) : undefined,
                });
            }
            else {
                this.clearTokens();
                this.onRefreshFailed?.();
                throw new Error('Session expired');
            }
        }
        if (!res.ok) {
            const err = await res.json().catch(() => ({ error: res.statusText }));
            throw new Error(err.error || `HTTP ${res.status}`);
        }
        if (res.status === 204)
            return undefined;
        return res.json();
    }
    async tryRefresh() {
        if (!this.refreshToken)
            return false;
        try {
            const res = await fetch(`${this.baseUrl}/api/auth/refresh`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ refreshToken: this.refreshToken }),
            });
            if (!res.ok)
                return false;
            const data = await res.json();
            this.accessToken = data.accessToken;
            this.refreshToken = data.refreshToken;
            return true;
        }
        catch {
            return false;
        }
    }
    get(path) {
        return this.request('GET', path);
    }
    post(path, body) {
        return this.request('POST', path, body);
    }
    put(path, body) {
        return this.request('PUT', path, body);
    }
    del(path) {
        return this.request('DELETE', path);
    }
}
//# sourceMappingURL=client.js.map